import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loaSummary: {
    numberOfLOAs: 0,
    numberOfAgenciesWithLOAs: 0,
    numberOfMDAsWithLOAs: 0,
    activeLoaValue: 0,
  },

  error: {},
  refreshList: false,
  loading: false,
};

const LOASlice = createSlice({
  name: "LOASlice",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setLoaSummary: (state, action) => {
      state.loaSummary = action.payload;
    },
  },
  extraReducers: (builder) => {},
});

export const { setLoading, setLoaSummary } = LOASlice.actions;

export default LOASlice.reducer;
